import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import useLicenseSx from '../hooks/useLicenseSx';

export default function LicenseArchiveDialog({
  open,
  license,
  isSubmitting = false,
  onClose,
  onConfirm,
}) {
  const styles = useLicenseSx().dialog;

  return (
    <Dialog
      open={open}
      onClose={isSubmitting ? undefined : onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: styles.paper }}
    >
      <DialogTitle sx={styles.title}>Archive License</DialogTitle>
      <DialogContent sx={styles.content}>
        <Typography variant="body2" color="text.secondary">
          Archive <strong>{license?.alias || license?.name}</strong>? Archived plans stay in the
          system for history but cannot be assigned to new organisations.
        </Typography>
      </DialogContent>
      <DialogActions sx={styles.actions}>
        <Button onClick={onClose} disabled={isSubmitting} sx={styles.cancelButton}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="warning"
          onClick={onConfirm}
          disabled={isSubmitting}
          sx={styles.submitButton}
        >
          {isSubmitting ? 'Archiving...' : 'Archive'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
